import { endpoints } from 'api/endpoints'
import { GetOneResponse } from 'interfaces/api.interfaces'
import { LoginData, TokenResponse } from 'interfaces/api/auth.interfaces'
import { axios } from 'modules/axios'

const login = async (data: LoginData): GetOneResponse<string> => {
  const { data: response } = await axios.request<TokenResponse>({
    method: 'POST',
    url: endpoints.auth.login(),
    data,
  })
  return response.access
}

export const authApi = {
  login,
}
